import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import Retry from "./RetryMessage";
import { s360ConfigService } from "../../Services/S360Config";

class VideoMessage extends Component {
  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return  s360ConfigService.config.autoFullScreen?"s360-message-box-received-fs": "s360-message-box-received";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.sent:
        return {
          background: "#FFFFFF",
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
        };
      case MessageType.received:
        return {
          background: "#FFFFFF",
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
          textAlign: config.designDetails.incomingMessageTextAlign || 'left',
          marginRight: '0',
        };
      case MessageType.sent:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  render() {
    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        <div
          className={this.messageBoxClassName()}
          style={this.messageBoxStyle()}
        >
          <video controls width="250" style={{ width: "75%" }}>
            <source src={this.props.message.message.text} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
          {this.showMessageTime() && (
            <div
              className={this.messageTimeClassName()}
              style={this.messageTimeStyle()}
            >
              {dayjs
                .unix(
                  Math.trunc(
                    this?.props?.message?.message?.sentTimestamp / 1000
                  )
                )
                .format("DD MMM h:mm a")}
            </div>
          )}

          <Retry {...this.props} />
        </div>
      </div>
    );
  }
}

export default VideoMessage;
